module.exports = __webpack_public_path__ + "img/地图-深色镂空.2d7e1a3c.png";